export const LANGS = [
  { code: "EN", label: "English", value: "en" },
  { code: "ES", label: "Español", value: "es" },
  { code: "RO", label: "Română", value: "ro" },
];

// Static, language-agnostic product info. All text lives in translations[lang].productItems
export const PRODUCT_ORDER = [
  "advanced-electrician-job",
  "basic-package",
  "medium-package",
  "advanced-package",
  "bug-error-fixes",
  "resource-db-optimization",
  "monthly-maintenance",
  "dedicated-developer",
];

export const translations = {
  en: {
    nav: { products: "Products", howItWorks: "How it works" },
    hero: {
      badge: "Available for new orders",
      title1: "Scripts & services",
      title2: "built with care.",
      subtitle:
        "FiveM scripts, Discord bots and custom development. Order directly through Discord — fast, personal, no middlemen.",
      viewProducts: "View products",
      contactDiscord: "Contact on Discord",
    },
    stats: [
      { value: "50+", label: "Projects delivered" },
      { value: "24/7", label: "Support on Discord" },
      { value: "100%", label: "Clean code" },
    ],
    marquee: ["CLEAN CODE", "24/7 SUPPORT", "CUSTOM DEV", "FIVEM SCRIPTS", "DISCORD BOTS", "NO MIDDLEMEN"],
    products: {
      eyebrow: "Catalog",
      title: "Products & services",
      subtitle: "Every product is tested, documented, and comes with direct support on Discord.",
      buy: "Buy",
      price: "Price",
      included: "What's included",
      buyOnDiscord: "Buy on Discord",
      buyToast: "Opening Discord for",
      buyToastDesc: "Open a ticket and I'll get you sorted.",
    },
    how: {
      eyebrow: "Process",
      title: "How to buy",
      subtitle: "No complicated checkout. Talk to me directly on Discord and get your product instantly.",
      steps: {
        "01": { title: "Open Discord", text: "Join my server and open a ticket for the product you want." },
        "02": { title: "Confirm payment", text: "Send payment using your preferred method (PayPal, crypto, Revolut)." },
        "03": { title: "Receive your product", text: "I deliver the files + instructions and stay available for setup." },
      },
    },
    terms: {
      eyebrow: "Terms",
      title: "Terms & guarantees",
      items: [
        "50% deposit before starting custom projects (or full payment for small amounts).",
        "Delivery time is agreed together directly in the ticket.",
        "Free warranty and support for bugs that appear right after delivery.",
        "For any service, open a ticket in the dedicated Discord channel.",
      ],
    },
    cta: {
      title: "Ready to get started?",
      subtitle: "Join Discord, open a ticket and let's talk about your project.",
      join: "Join Discord",
    },
    footer: { copyright: "built with care." },
    common: { discord: "Discord" },
    productItems: {
      "advanced-electrician-job": {
        tag: "FiveM Script", title: "Advanced Electrician Job", price: "$20",
        short: "Standalone script (vRP configured) with 3 React NUI mini-games, cinematic dialogue and an electrocution system.",
        features: ["Cinematic React NUI (Wire / Voltage / Fuse)", "Electrocution with ragdoll & VFX", "Uniform change + vehicle fleet", "Standalone / ESX / QBCore"],
        long: "A complete, ready-to-run electrician job built for immersion. Players progress through three custom React NUI mini-games — wiring, voltage balancing and fuse repair — each with escalating difficulty and a realistic electrocution system featuring ragdoll and particle VFX.",
        includes: ["Full source (obfuscation optional)", "Config for payouts, cooldowns & zones", "Uniform + dedicated vehicle fleet", "Framework adapters: Standalone / ESX / QBCore"],
      },
      "basic-package": {
        tag: "Custom Scripting", title: "Basic Package", price: "from $10",
        short: "Quick changes and small fixes to existing scripts. Ideal for minor tweaks.",
        features: ["Script tweaks", "Small fixes", "Fast delivery", "Post-delivery warranty"],
        long: "The fastest way to get small changes done. Perfect for tweaking configs, adjusting values, fixing a broken feature or adding a minor tweak to a script you already own.",
        includes: ["Same-day turnaround on small tasks", "Clear before/after summary", "Short post-delivery warranty"],
      },
      "medium-package": {
        tag: "Custom Scripting", title: "Medium Package", price: "$25 – $50",
        short: "Medium systems and jobs developed to your requirements, fully integrated into your server.",
        features: ["Custom jobs", "Medium systems", "Config included", "Installation support"],
        long: "Mid-sized systems built to your spec and integrated cleanly into your existing framework. Includes a documented config and hands-on installation support.",
        includes: ["Custom job or system from a brief", "Fully documented config", "Installation & setup support"],
      },
      "advanced-package": {
        tag: "Custom Scripting", title: "Advanced Package", price: "$60+",
        short: "Complex systems with custom React/NUI, scalable architecture and a cinematic UI.",
        features: ["Custom React / NUI", "Complex systems", "Optimized code", "Price based on complexity"],
        long: "For ambitious features. Bespoke React/NUI interfaces, scalable server architecture and a cinematic feel — engineered for performance and long-term maintainability.",
        includes: ["Custom cinematic React/NUI", "Scalable, optimized architecture", "Quote based on complexity"],
      },
      "bug-error-fixes": {
        tag: "Maintenance", title: "Bug & Error Fixes", price: "from $10",
        short: "Fixing console errors, gameplay bugs and one-off issues on your server.",
        features: ["Fast diagnosis", "Per-issue fix", "Detailed report", "7-day warranty"],
        long: "Track down and squash the errors flooding your console. Each issue is diagnosed, fixed and documented, with a 7-day warranty on the fix.",
        includes: ["Rapid diagnosis", "Per-issue pricing", "Detailed written report", "7-day warranty"],
      },
      "resource-db-optimization": {
        tag: "Maintenance", title: "Resource & DB Optimization", price: "$20 – $40",
        short: "Improved MS / Resmon, database indexes and elimination of leaks.",
        features: ["Resmon audit", "MySQL optimization", "Reduced ms", "Written recommendations"],
        long: "A full performance pass on your server. I audit resmon, optimize MySQL queries and indexes, hunt down memory leaks and hand you written recommendations to keep ms low.",
        includes: ["Complete Resmon audit", "MySQL query & index optimization", "Leak elimination", "Written recommendations"],
      },
      "monthly-maintenance": {
        tag: "Subscription", title: "Monthly Maintenance", price: "Subscription",
        short: "Constant fixes, security updates and priority technical support every month.",
        features: ["Fixes included", "Security updates", "Priority support", "No contract"],
        long: "Keep your server healthy without lifting a finger. A monthly retainer covering ongoing fixes, security updates and priority support — cancel anytime, no contract.",
        includes: ["Ongoing bug fixes", "Security updates", "Priority Discord support", "No contract — cancel anytime"],
      },
      "dedicated-developer": {
        tag: "Subscription", title: "Dedicated Developer", price: "Subscription",
        short: "Full-time / part-time developer for your server: new resources, bug fixes, development and consulting.",
        features: ["Guaranteed weekly hours", "Fast availability", "Development from scratch", "Technical consulting"],
        long: "Your own developer on retainer. Guaranteed weekly hours for new resources, fixes, from-scratch development and technical consulting — fast availability, always on Discord.",
        includes: ["Guaranteed weekly hours", "Fast availability", "Development from scratch", "Technical consulting"],
      },
    },
  },

  es: {
    nav: { products: "Productos", howItWorks: "Cómo funciona" },
    hero: {
      badge: "Disponible para nuevos pedidos",
      title1: "Scripts y servicios",
      title2: "hechos con cariño.",
      subtitle:
        "Scripts de FiveM, bots de Discord y desarrollo a medida. Pide directamente por Discord — rápido, personal, sin intermediarios.",
      viewProducts: "Ver productos",
      contactDiscord: "Contactar por Discord",
    },
    stats: [
      { value: "50+", label: "Proyectos entregados" },
      { value: "24/7", label: "Soporte en Discord" },
      { value: "100%", label: "Código limpio" },
    ],
    marquee: ["CÓDIGO LIMPIO", "SOPORTE 24/7", "DESARROLLO A MEDIDA", "SCRIPTS FIVEM", "BOTS DISCORD", "SIN INTERMEDIARIOS"],
    products: {
      eyebrow: "Catálogo",
      title: "Productos y servicios",
      subtitle: "Cada producto está probado, documentado y con soporte directo en Discord.",
      buy: "Comprar",
      price: "Precio",
      included: "Qué incluye",
      buyOnDiscord: "Comprar en Discord",
      buyToast: "Abriendo Discord para",
      buyToastDesc: "Abre un ticket y me encargo de todo.",
    },
    how: {
      eyebrow: "Proceso",
      title: "Cómo comprar",
      subtitle: "Sin pagos complicados. Habla conmigo directamente en Discord y consigue tu producto al instante.",
      steps: {
        "01": { title: "Abre Discord", text: "Únete a mi servidor y abre un ticket para el producto que quieras." },
        "02": { title: "Confirma el pago", text: "Envía el pago con tu método preferido (PayPal, cripto, Revolut)." },
        "03": { title: "Recibe tu producto", text: "Te entrego los archivos + instrucciones y quedo disponible para la instalación." },
      },
    },
    terms: {
      eyebrow: "Términos",
      title: "Términos y garantías",
      items: [
        "50% de depósito antes de empezar proyectos personalizados (o pago completo para importes pequeños).",
        "El tiempo de entrega se acuerda juntos directamente en el ticket.",
        "Garantía y soporte gratis para bugs que aparezcan justo tras la entrega.",
        "Para cualquier servicio, abre un ticket en el canal de Discord dedicado.",
      ],
    },
    cta: {
      title: "¿Listo para empezar?",
      subtitle: "Únete a Discord, abre un ticket y hablemos de tu proyecto.",
      join: "Unirse a Discord",
    },
    footer: { copyright: "hecho con cariño." },
    common: { discord: "Discord" },
    productItems: {
      "advanced-electrician-job": {
        tag: "Script FiveM", title: "Advanced Electrician Job", price: "$20",
        short: "Script standalone (configurado vRP) con 3 minijuegos en React NUI, diálogos cinematográficos y un sistema de electrocución.",
        features: ["React NUI cinematográfico (Cable / Voltaje / Fusible)", "Electrocución con ragdoll y VFX", "Cambio de uniforme + flota de vehículos", "Standalone / ESX / QBCore"],
        long: "Un trabajo de electricista completo y listo para usar, pensado para la inmersión. Los jugadores avanzan por tres minijuegos personalizados en React NUI — cableado, equilibrio de voltaje y reparación de fusibles — cada uno con dificultad creciente y un sistema realista de electrocución con ragdoll y VFX de partículas.",
        includes: ["Código fuente completo (ofuscación opcional)", "Config de pagos, cooldowns y zonas", "Uniforme + flota de vehículos dedicada", "Adaptadores: Standalone / ESX / QBCore"],
      },
      "basic-package": {
        tag: "Scripting a medida", title: "Basic Package", price: "desde $10",
        short: "Cambios rápidos y pequeñas correcciones en scripts existentes. Ideal para ajustes menores.",
        features: ["Ajustes de script", "Pequeñas correcciones", "Entrega rápida", "Garantía post-entrega"],
        long: "La forma más rápida de hacer cambios pequeños. Perfecto para ajustar configs, cambiar valores, arreglar una función rota o añadir un pequeño ajuste a un script que ya tienes.",
        includes: ["Entrega el mismo día en tareas pequeñas", "Resumen claro de antes/después", "Garantía corta post-entrega"],
      },
      "medium-package": {
        tag: "Scripting a medida", title: "Medium Package", price: "$25 – $50",
        short: "Sistemas y trabajos medianos desarrollados a tu medida, totalmente integrados en tu servidor.",
        features: ["Trabajos personalizados", "Sistemas medianos", "Config incluida", "Soporte de instalación"],
        long: "Sistemas de tamaño medio creados a tu especificación e integrados limpiamente en tu framework existente. Incluye una config documentada y soporte de instalación práctico.",
        includes: ["Trabajo o sistema personalizado desde un brief", "Config totalmente documentada", "Soporte de instalación y configuración"],
      },
      "advanced-package": {
        tag: "Scripting a medida", title: "Advanced Package", price: "$60+",
        short: "Sistemas complejos con React/NUI personalizado, arquitectura escalable y una UI cinematográfica.",
        features: ["React / NUI personalizado", "Sistemas complejos", "Código optimizado", "Precio según complejidad"],
        long: "Para funciones ambiciosas. Interfaces React/NUI a medida, arquitectura de servidor escalable y un toque cinematográfico — diseñado para el rendimiento y el mantenimiento a largo plazo.",
        includes: ["React/NUI cinematográfico personalizado", "Arquitectura escalable y optimizada", "Presupuesto según complejidad"],
      },
      "bug-error-fixes": {
        tag: "Mantenimiento", title: "Bug & Error Fixes", price: "desde $10",
        short: "Corrección de errores de consola, bugs de juego y problemas puntuales en tu servidor.",
        features: ["Diagnóstico rápido", "Corrección por incidencia", "Informe detallado", "Garantía de 7 días"],
        long: "Localizo y elimino los errores que llenan tu consola. Cada incidencia se diagnostica, se corrige y se documenta, con una garantía de 7 días sobre la corrección.",
        includes: ["Diagnóstico rápido", "Precio por incidencia", "Informe escrito detallado", "Garantía de 7 días"],
      },
      "resource-db-optimization": {
        tag: "Mantenimiento", title: "Resource & DB Optimization", price: "$20 – $40",
        short: "Mejora de MS / Resmon, índices de base de datos y eliminación de fugas.",
        features: ["Auditoría de Resmon", "Optimización MySQL", "Menos ms", "Recomendaciones escritas"],
        long: "Una revisión completa de rendimiento de tu servidor. Audito resmon, optimizo consultas e índices MySQL, cazo fugas de memoria y te entrego recomendaciones escritas para mantener los ms bajos.",
        includes: ["Auditoría completa de Resmon", "Optimización de consultas e índices MySQL", "Eliminación de fugas", "Recomendaciones escritas"],
      },
      "monthly-maintenance": {
        tag: "Suscripción", title: "Monthly Maintenance", price: "Suscripción",
        short: "Correcciones constantes, actualizaciones de seguridad y soporte técnico prioritario cada mes.",
        features: ["Correcciones incluidas", "Actualizaciones de seguridad", "Soporte prioritario", "Sin contrato"],
        long: "Mantén tu servidor sano sin mover un dedo. Una cuota mensual que cubre correcciones continuas, actualizaciones de seguridad y soporte prioritario — cancela cuando quieras, sin contrato.",
        includes: ["Correcciones de bugs continuas", "Actualizaciones de seguridad", "Soporte prioritario en Discord", "Sin contrato — cancela cuando quieras"],
      },
      "dedicated-developer": {
        tag: "Suscripción", title: "Dedicated Developer", price: "Suscripción",
        short: "Desarrollador a tiempo completo / parcial para tu servidor: nuevos recursos, correcciones, desarrollo y consultoría.",
        features: ["Horas semanales garantizadas", "Disponibilidad rápida", "Desarrollo desde cero", "Consultoría técnica"],
        long: "Tu propio desarrollador en exclusiva. Horas semanales garantizadas para nuevos recursos, correcciones, desarrollo desde cero y consultoría técnica — disponibilidad rápida, siempre en Discord.",
        includes: ["Horas semanales garantizadas", "Disponibilidad rápida", "Desarrollo desde cero", "Consultoría técnica"],
      },
    },
  },

  ro: {
    nav: { products: "Produse", howItWorks: "Cum funcționează" },
    hero: {
      badge: "Disponibil pentru comenzi noi",
      title1: "Scripturi și servicii",
      title2: "făcute cu grijă.",
      subtitle:
        "Scripturi FiveM, boți de Discord și dezvoltare personalizată. Comandă direct prin Discord — rapid, personal, fără intermediari.",
      viewProducts: "Vezi produsele",
      contactDiscord: "Contactează pe Discord",
    },
    stats: [
      { value: "50+", label: "Proiecte livrate" },
      { value: "24/7", label: "Suport pe Discord" },
      { value: "100%", label: "Cod curat" },
    ],
    marquee: ["COD CURAT", "SUPORT 24/7", "DEZVOLTARE PERSONALIZATĂ", "SCRIPTURI FIVEM", "BOȚI DISCORD", "FĂRĂ INTERMEDIARI"],
    products: {
      eyebrow: "Catalog",
      title: "Produse și servicii",
      subtitle: "Fiecare produs este testat, documentat și vine cu suport direct pe Discord.",
      buy: "Cumpără",
      price: "Preț",
      included: "Ce include",
      buyOnDiscord: "Cumpără pe Discord",
      buyToast: "Se deschide Discord pentru",
      buyToastDesc: "Deschide un tichet și mă ocup de tot.",
    },
    how: {
      eyebrow: "Proces",
      title: "Cum cumperi",
      subtitle: "Fără checkout complicat. Vorbește direct cu mine pe Discord și primești produsul instant.",
      steps: {
        "01": { title: "Deschide Discord", text: "Intră pe serverul meu și deschide un tichet pentru produsul dorit." },
        "02": { title: "Confirmă plata", text: "Trimite plata cu metoda preferată (PayPal, cripto, Revolut)." },
        "03": { title: "Primește produsul", text: "Livrez fișierele + instrucțiunile și rămân disponibil pentru instalare." },
      },
    },
    terms: {
      eyebrow: "Termeni",
      title: "Termeni și garanții",
      items: [
        "Avans de 50% înainte de a începe proiecte personalizate (sau plată integrală pentru sume mici).",
        "Timpul de livrare se stabilește împreună direct în tichet.",
        "Garanție și suport gratuit pentru bugurile care apar imediat după livrare.",
        "Pentru orice serviciu, deschide un tichet pe canalul dedicat de Discord.",
      ],
    },
    cta: {
      title: "Gata să începem?",
      subtitle: "Intră pe Discord, deschide un tichet și hai să discutăm despre proiectul tău.",
      join: "Intră pe Discord",
    },
    footer: { copyright: "făcut cu grijă." },
    common: { discord: "Discord" },
    productItems: {
      "advanced-electrician-job": {
        tag: "Script FiveM", title: "Advanced Electrician Job", price: "$20",
        short: "Script standalone (configurat vRP) cu 3 minijocuri React NUI, dialog cinematic și un sistem de electrocutare.",
        features: ["React NUI cinematic (Fir / Voltaj / Siguranță)", "Electrocutare cu ragdoll și VFX", "Schimbare uniformă + flotă de vehicule", "Standalone / ESX / QBCore"],
        long: "Un job de electrician complet, gata de rulare, construit pentru imersiune. Jucătorii progresează prin trei minijocuri React NUI personalizate — cablare, echilibrarea voltajului și repararea siguranțelor — fiecare cu dificultate crescândă și un sistem realist de electrocutare cu ragdoll și VFX de particule.",
        includes: ["Sursă completă (ofuscare opțională)", "Config pentru plăți, cooldown-uri și zone", "Uniformă + flotă de vehicule dedicată", "Adaptoare: Standalone / ESX / QBCore"],
      },
      "basic-package": {
        tag: "Scripting personalizat", title: "Basic Package", price: "de la $10",
        short: "Modificări rapide și corecturi mici la scripturi existente. Ideal pentru ajustări minore.",
        features: ["Ajustări de script", "Corecturi mici", "Livrare rapidă", "Garanție după livrare"],
        long: "Cel mai rapid mod de a face modificări mici. Perfect pentru ajustarea config-urilor, schimbarea valorilor, repararea unei funcții stricate sau adăugarea unei mici modificări la un script pe care îl ai deja.",
        includes: ["Livrare în aceeași zi pentru sarcini mici", "Rezumat clar înainte/după", "Garanție scurtă după livrare"],
      },
      "medium-package": {
        tag: "Scripting personalizat", title: "Medium Package", price: "$25 – $50",
        short: "Sisteme și joburi medii dezvoltate după cerințele tale, integrate complet în serverul tău.",
        features: ["Joburi personalizate", "Sisteme medii", "Config inclus", "Suport la instalare"],
        long: "Sisteme de dimensiune medie construite după specificațiile tale și integrate curat în framework-ul existent. Include un config documentat și suport practic la instalare.",
        includes: ["Job sau sistem personalizat pornind de la un brief", "Config complet documentat", "Suport la instalare și configurare"],
      },
      "advanced-package": {
        tag: "Scripting personalizat", title: "Advanced Package", price: "$60+",
        short: "Sisteme complexe cu React/NUI personalizat, arhitectură scalabilă și un UI cinematic.",
        features: ["React / NUI personalizat", "Sisteme complexe", "Cod optimizat", "Preț în funcție de complexitate"],
        long: "Pentru funcții ambițioase. Interfețe React/NUI la comandă, arhitectură de server scalabilă și un aer cinematic — proiectate pentru performanță și mentenanță pe termen lung.",
        includes: ["React/NUI cinematic personalizat", "Arhitectură scalabilă și optimizată", "Ofertă în funcție de complexitate"],
      },
      "bug-error-fixes": {
        tag: "Mentenanță", title: "Bug & Error Fixes", price: "de la $10",
        short: "Rezolvarea erorilor din consolă, a bugurilor de gameplay și a problemelor punctuale de pe serverul tău.",
        features: ["Diagnostic rapid", "Reparație per problemă", "Raport detaliat", "Garanție 7 zile"],
        long: "Găsesc și elimin erorile care îți umplu consola. Fiecare problemă este diagnosticată, reparată și documentată, cu o garanție de 7 zile pentru reparație.",
        includes: ["Diagnostic rapid", "Preț per problemă", "Raport scris detaliat", "Garanție 7 zile"],
      },
      "resource-db-optimization": {
        tag: "Mentenanță", title: "Resource & DB Optimization", price: "$20 – $40",
        short: "MS / Resmon îmbunătățit, indecși de bază de date și eliminarea scurgerilor.",
        features: ["Audit Resmon", "Optimizare MySQL", "ms redus", "Recomandări scrise"],
        long: "O trecere completă de performanță pe serverul tău. Auditez resmon, optimizez interogările și indecșii MySQL, vânez scurgerile de memorie și îți ofer recomandări scrise pentru a menține ms scăzut.",
        includes: ["Audit Resmon complet", "Optimizare interogări și indecși MySQL", "Eliminarea scurgerilor", "Recomandări scrise"],
      },
      "monthly-maintenance": {
        tag: "Abonament", title: "Monthly Maintenance", price: "Abonament",
        short: "Corecturi constante, actualizări de securitate și suport tehnic prioritar în fiecare lună.",
        features: ["Corecturi incluse", "Actualizări de securitate", "Suport prioritar", "Fără contract"],
        long: "Menține-ți serverul sănătos fără efort. Un abonament lunar care acoperă corecturi continue, actualizări de securitate și suport prioritar — anulezi oricând, fără contract.",
        includes: ["Corecturi de buguri continue", "Actualizări de securitate", "Suport prioritar pe Discord", "Fără contract — anulezi oricând"],
      },
      "dedicated-developer": {
        tag: "Abonament", title: "Dedicated Developer", price: "Abonament",
        short: "Dezvoltator full-time / part-time pentru serverul tău: resurse noi, corecturi, dezvoltare și consultanță.",
        features: ["Ore săptămânale garantate", "Disponibilitate rapidă", "Dezvoltare de la zero", "Consultanță tehnică"],
        long: "Propriul tău dezvoltator dedicat. Ore săptămânale garantate pentru resurse noi, corecturi, dezvoltare de la zero și consultanță tehnică — disponibilitate rapidă, mereu pe Discord.",
        includes: ["Ore săptămânale garantate", "Disponibilitate rapidă", "Dezvoltare de la zero", "Consultanță tehnică"],
      },
    },
  },
};
